import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-activate-plus-icon",
    templateUrl: "./activate-plus-icon.component.html",
    styleUrls: ["./activate-plus-icon.component.scss"],
    standalone: false
})
export class ActivatePlusIconComponent implements OnInit {
  param: any;
  constructor() {}

  ngOnInit() {}
}
